export default "__VITE_PUBLIC_ASSET__ab27530f__"